import Modal from "../Modal/Modal";
import { StyledButton } from "../styled/styled-components";
import BankTransferInfo from "./BankTransferInfo";

interface IProps {
  onCloseModal?: () => void;
  closeButtonName?: string;
}

const BankTransferInfoModal = (props: IProps) => {
  const { onCloseModal, closeButtonName = "Close" } = props;
  return (
    <Modal>
      <div className="bank-transfer-info-modal">
        <BankTransferInfo />
        <div className="actions">
          {onCloseModal && <StyledButton onClick={onCloseModal}>{closeButtonName}</StyledButton>}
        </div>
      </div>
    </Modal>
  );
};

export default BankTransferInfoModal;
